module.exports = __webpack_public_path__ + "static/media/menuLibrary.19f5f89f.svg";